import { DeliveryProvider } from '@/Store/Providers/delivery_provider';
import { TruckInspectionsProvider } from '@/Store/Providers/truck_inspections_provider';
import { combineComponents } from '@/Store/Utils/combine-components';

const providers = [
    DeliveryProvider,
    TruckInspectionsProvider
];

export const AppContextProvider = combineComponents(...providers);
